<template>
    <div class="container-fluid">
        <div class="row p-1 pt-2 text-center text-md-left border-primary border-top border-bottom">
            <div class="col-12 col-md-8">
                <router-link to="/" class="text-dark">
                    <h3 class="header-style text-responsive">
                        <!-- use https://favicon.io/favicon-converter/ -->
                        <span class="mx-2 text-primary"><font-awesome-icon icon="eye"/></span>
                        <span class="text-primary">T</span>herapeutic <span class="text-primary">C</span>olor <span
                            class="text-primary">I</span>ndicator
                    </h3>
                </router-link>
            </div>
            <div class="col-12 col-md-4 text-center text-md-right no-print">
                <router-link to="/history" class="btn btn-outline-primary mr-1">
                    <i class="fas fa-history"></i> Recent Tests
                </router-link>

                <router-link to="/help" class="btn btn-outline-primary">
                    <i class="fas fa-question"></i> Help
                </router-link>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'TopHeader',
    };
</script>

<style lang="scss" scoped>
    .header-style {
        font-family: "Open Sans", serif !important;
        font-weight: 600 !important;
    }

    .border-top {
        border-top-width: 5px !important;
    }

    @media print {
        .no-print, .no-print * {
            display: none !important;
        }
    }

    /* tiny device such as iphone 5*/
    h3 {
        font-size: 1.2rem;
        margin-bottom: 1rem;
    }

    /*  bigger device such as pixel */
    @media (min-width: 350px) {
        h3 {
            font-size: 1.4rem;
        }
    }

    /* Small devices (landscape phones, 544px and up) */
    @media (min-width: 544px) {
        h3 {
            font-size: 1.7rem;
        }
    }

    /* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
    @media (min-width: 768px) {
        h3 {
            margin-bottom: 0rem;
        }
    }

    /*1rem = 16px*/
</style>
